
// TODO: could be a hook
import { keccak256 } from '@ethersproject/keccak256';
import { pack } from '@ethersproject/solidity';
import { getCreate2Address } from '@ethersproject/address';

import { Address } from 'types/interfaces';

const getPairAddress = (
  tokenA: Address,
  tokenB: Address,
  uniswapV2FactoryAddress: Address
): string => {
  const [token0, token1] = tokenA < tokenB ? [tokenA, tokenB] : [tokenB, tokenA];
  const salt = keccak256(pack(['address', 'address'], [token0, token1]));

  return getCreate2Address(
    uniswapV2FactoryAddress,
    salt,
    // TODO: hardcoded
    '0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5'
  );
};

export default getPairAddress;
